import FrameworkHandler from "./FrameworkHandler";

export default class WrapperIntegration
{
    private frameworkHandler: FrameworkHandler = new FrameworkHandler();

    public initSwContext(): void {
        this.frameworkHandler.initSwContext()
    }


    public start(): void
    {
        this.initFrameworkDispatcher();
    }

    public useExternalMessageBox(message: any): boolean
    {
        return this.frameworkHandler.useExternalMessageBox(message);
    }

    private initFrameworkDispatcher(): void
    {
        this.frameworkHandler.init();
    }

    public formatNumber(value: number, settings: any): string
    {
        return this.frameworkHandler.formatNumber(value, settings);
    }

    public onLoadingProgress(progress: number): void
    {
        this.frameworkHandler.onLoadingProgress(progress);
    }
}